'use client';
import { jsx } from 'react/jsx-runtime';
import { useStepIndicatorContext } from './step-indicator-context.js';
import { classNames } from '../../../core/utilities/classnames.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)r = p[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)r = p[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const StepIndicatorStep = renderWithRef('StepIndicatorStep', null, (o, p)=>{
    let { currentStepNumber: i } = useStepIndicatorContext(), { stepNumber: c = 1, children: s } = o, u = _object_without_properties(o, [
        "stepNumber",
        "children"
    ]);
    return jsx(RenderComp, {
        root: "li",
        forwardedRef: p,
        classNames: classNames(new Set([
            'swan-step'
        ]), {
            'swan-step-past': c < i,
            'swan-step-previous': c === i - 1,
            'swan-step-current': c === i,
            'swan-step-next': c === i + 1,
            'swan-step-future': c > i
        }),
        props: _object_spread({}, u, c === i ? {
            'aria-current': 'step'
        } : {}),
        children: s
    });
});

export { StepIndicatorStep };
